// Lightweight, dependency-free renderer for AI markdown output (headings, bold, bullets).
function inline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**")
      ? <strong key={i} className="text-white font-semibold">{p.slice(2, -2)}</strong>
      : <span key={i}>{p}</span>
  );
}

export function AiMarkdown({ text, className = "", ...rest }) {
  const lines = String(text || "").split("\n");
  const blocks = [];
  let list = [];
  const flush = (key) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${key}`} className="list-disc pl-5 space-y-1 my-2">
          {list.map((li, i) => <li key={i}>{inline(li)}</li>)}
        </ul>
      );
      list = [];
    }
  };
  lines.forEach((raw, idx) => {
    const line = raw.trim();
    if (!line) { flush(idx); return; }
    const h = line.match(/^(#{1,4})\s+(.*)$/);
    const bullet = line.match(/^[-*]\s+(.*)$/);
    if (h) {
      flush(idx);
      blocks.push(<h4 key={idx} className="text-[#D4AF37] font-heading text-sm uppercase tracking-wide mt-3 mb-1">{inline(h[2])}</h4>);
    } else if (bullet) {
      list.push(bullet[1]);
    } else {
      flush(idx);
      blocks.push(<p key={idx} className="mb-2">{inline(line)}</p>);
    }
  });
  flush("end");
  return <div className={className} {...rest}>{blocks}</div>;
}
